import { Select } from '@99designs/common/components/Select';
import { Industry } from '__generated__/Industry';
import { handlePromise } from 'common/utils/Bugsnag';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    industry: string;
}

interface Props<T> {
    form: ObservableForm<T>;
    industries: Industry[];
}

const IndustryField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    industries,
}) => {
    return (
        <Field
            form={form}
            name="industry"
            title={__('What industry are you in?')}
            render={() => (
                <Select
                    name="industry"
                    options={[
                        { label: __('Select industry'), value: '', disabled: true },
                        ...industries
                            .sort((a, b) => a.title.localeCompare(b.title))
                            .map(({ key, title }) => ({ label: title, value: key })),
                    ]}
                    value={form.get('industry')}
                    onChange={({ value }: { value: string }) => {
                        handlePromise(form.set('industry', value), 'AboutYouPage');
                    }}
                    variations={['max']}
                />
            )}
        />
    );
};

export default IndustryField;
